(function () {
  const productsFilters = () => {
    const products = document.querySelectorAll('.collection-popular-card');
    const limit = products.length;

    document.querySelectorAll('.filters__item').forEach(item => {      
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const typeTarget = item.dataset.typeTarget;
        document.querySelectorAll('.filters__item').forEach(element => {
          element.classList.remove('filters__item_active');
        });
        item.classList.add('filters__item_active');

        let i = 0;
        products.forEach(element => {
          let productType = element.dataset.type;
          if ((productType == typeTarget || typeTarget == "all") && i < limit) {
            element.classList.add('show');
            i++;
          } else {
            element.classList.remove('show');
          }
        });
      });
    });
  };

  function initPopularAjaxAddToCart(root) {
    var section = root || document;
    var forms = section.querySelectorAll('.js-popular-add-to-cart-form');
    if (!forms.length) return;

    var cartDrawer = document.querySelector('cart-drawer');
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    forms.forEach(function (form) {
      if (form.dataset.popularAjaxBound === 'true') return;
      form.dataset.popularAjaxBound = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn && submitBtn.disabled) return;

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.classList.add('loading');
        }

        var formData = new FormData(form);
        if (cartDrawer) {
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }

        var config = {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          credentials: 'same-origin'
        };

        if (typeof window.fetch === 'undefined') {
          form.submit();
          return;
        }

        fetch(addUrl, config)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status && data.status !== 200) {
              console.error('Popular products add-to-cart error:', data);
              return;
            }

            // Let any global listeners update cart badge, etc.
            try {
              document.dispatchEvent(new CustomEvent('cart:change'));
            } catch (e) {
              console.error('Error dispatching cart:change from popular products:', e);
            }

            // Update drawer contents and open it
            if (cartDrawer && data.sections) {
              cartDrawer.renderContents(data);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          })
          .catch(function (error) {
            console.error('Popular products AJAX add-to-cart failed:', error);
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-disabled');
              submitBtn.classList.remove('loading');
            }
          });
      });
    });
  }

  function init() {
    productsFilters();
    initPopularAjaxAddToCart(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event.target;
    productsFilters();
    initPopularAjaxAddToCart(sectionRoot);
  });
})();